module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('m-header', {
    attrs: {
      "title": "售后详情"
    }
  }), _vm._v(" "), (_vm.item) ? _c('div', {
    staticClass: "refund-box text-l"
  }, [_c('div', {
    staticClass: "vux-1px-b"
  }, [_c('span', [_c('i', {
    staticClass: "icon-tuikuan1 iconfont"
  }), _vm._v(_vm._s(_vm._f("statusName2")(_vm.item.aftersales_type)))])]), _vm._v(" "), _c('div', {
    staticClass: "vux-1px-b"
  }, [_c('span', [_vm._v("售后状态：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("statusName")(_vm.item.status)))])]), _vm._v(" "), _c('div', {
    staticClass: "vux-1px-b"
  }, [_c('span', [_vm._v("申请时间：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("timerForm")(_vm.item.created_time)))])]), _vm._v(" "), _c('div', {
    staticClass: "vux-1px-b"
  }, [_c('span', [_vm._v("售后编码：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.aftersales_bn))])]), _vm._v(" "), _c('div', {
    staticClass: "vux-1px-b"
  }, [_c('span', [_vm._v("申请理由：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.reason))])]), _vm._v(" "), _vm._m(0)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-1px-b"
  }, [_c('span', [_vm._v("详情描述：")]), _vm._v(" "), _c('span', [_vm._v("无详细描述")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-794bbc5b"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderList/RefundDetail.vue
// module id = 587
// module chunks = 0